import React from "react";
import { Spinner } from "reactstrap";
import { Autocomplete, TextField } from "@mui/material";

const AddressCard = ({
  user,
  state,
  setState,
  city,
  setCity,
  school,
  setSchool,
  isEdit,
  setIsEdit,
  editLoader,
  handleChangeAddress,
  defaultStateProps,
  defaultCityProps,
  defaultNewSchoolProps,
}) => {
  return (
    <div className="saas-card">
      <div className="card-header-saas">
        <h3>Address & Institution</h3>
        {!isEdit ? (
          <button className="saas-btn secondary sm" onClick={() => setIsEdit(true)}>
            Edit
          </button>
        ) : (
          <div style={{ display: "flex", gap: "8px" }}>
            <button
              className="saas-btn primary sm"
              onClick={handleChangeAddress}
              disabled={
                !school ||
                editLoader ||
                (school === user?.institute_name &&
                  city === user?.city &&
                  state === user?.state)
              }
            >
              {editLoader ? <Spinner size="sm" /> : "Save"}
            </button>
            <button className="saas-btn secondary sm" onClick={() => setIsEdit(false)}>
              Cancel
            </button>
          </div>
        )}
      </div>

      <div className="info-field-group">
        {/* State */}
        <div className="info-row">
          <span className="info-label">State</span>
          {!isEdit ? (
            <span className="info-value">{user?.state || "N/A"}</span>
          ) : (
            <div style={{ width: "60%" }}>
              <Autocomplete
                options={[
                  ...(defaultStateProps.options || []),
                  { name: "OTHER" },
                ]}
                getOptionLabel={(option) =>
                  typeof option === "string"
                    ? option
                    : option?.name || ""
                }
                isOptionEqualToValue={(option, value) =>
                  (typeof option === "string"
                    ? option
                    : option?.name) ===
                  (typeof value === "string" ? value : value?.name)
                }
                required
                id="auto-complete-state"
                className="w-100"
                autoComplete
                includeInputInList
                value={typeof state === "string" ? { name: state } : state}
                onChange={(e, val) => {
                  if (!val) {
                    setState(null);
                    setCity("");
                    setSchool("");
                  } else if (val.name === "OTHER") {
                    setState("OTHER");
                    setCity("OTHER");
                    setSchool("OTHER");
                  } else {
                    setState(val);
                    setCity("");
                    setSchool("");
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    required
                    placeholder="Select State"
                    variant="standard"
                  />
                )}
              />
            </div>
          )}
        </div>

        {/* City */}
        <div className="info-row">
          <span className="info-label">City</span>
          {!isEdit ? (
            <span className="info-value">{user?.city || "N/A"}</span>
          ) : (
            <div style={{ width: "60%" }}>
              <Autocomplete
                {...defaultCityProps}
                required
                id="auto-complete-city"
                className="w-100"
                autoComplete
                value={city}
                includeInputInList
                onChange={(e, val) => {
                  if (!val) {
                    setCity("");
                    setSchool("");
                  } else if (val === "OTHER") {
                    setCity("OTHER");
                    setSchool("OTHER");
                  } else {
                    setCity(val);
                    setSchool("");
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    required
                    placeholder="Select City"
                    variant="standard"
                  />
                )}
              />
            </div>
          )}
        </div>

        {/* School */}
        <div className="info-row">
          <span className="info-label">School / College</span>
          {!isEdit ? (
            <span className="info-value">{user?.institute_name || "N/A"}</span>
          ) : (
            <div style={{ width: "60%" }}>
              <Autocomplete
                {...defaultNewSchoolProps}
                required
                id="auto-complete-school"
                autoComplete
                includeInputInList
                value={school}
                onChange={(e, val) => {
                  if (city === "OTHER") {
                    setSchool("OTHER");
                  } else {
                    setSchool(val);
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder="Select School"
                    variant="standard"
                    inputProps={{
                      ...params.inputProps,
                      readOnly: true,
                    }}
                  />
                )}
              />
            </div>
          )}
        </div>

        {/* Level */}
        <div className="info-row">
          <span className="info-label">Level</span>
          <span className="info-value">{user?.sportLevel || "N/A"}</span>
        </div>
      </div>
    </div>
  );
};

export default AddressCard;
